// The page a message is sent from (spec 2026-10-21-24 §12): the route, and
// the entity of the first UUID route param. A `code:` reference sends the
// route alone.

export type AssistantEntityType = 'asset' | 'contract' | 'contact' | 'intervention' | 'expense' | 'document' | 'import'

export interface PageContext {
    route: string
    entity_type?: AssistantEntityType
    entity_uid?: string
}

/** Route params, in priority order, and the entity each one names. */
const PARAMS: [string, AssistantEntityType][] = [
    ['assetUid', 'asset'],
    ['contractUid', 'contract'],
    ['userUid', 'contact'],
    ['interventionUid', 'intervention'],
    ['expenseUid', 'expense'],
    ['docUid', 'document'],
    ['importUid', 'import'],
]

const UUID = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i

export function pageContext(pathname: string, params: Record<string, unknown>): PageContext {
    const route = pathname.startsWith('/') ? pathname.slice(0, 512) : `/${pathname}`.slice(0, 512)
    for (const [name, type] of PARAMS) {
        const value = params[name]
        if (typeof value === 'string' && value !== '') {
            return UUID.test(value) ? { route, entity_type: type, entity_uid: value.toLowerCase() } : { route }
        }
    }
    return { route }
}
